<template>
  <div class="inner-change-password">
    <contentTitle v-if="$route.name == 'changeWord'" />
    <div class="change-word-form">
      <el-form :model="ruleForm" status-icon="" :rules="rules" ref="changePasswordForm" label-position="left" label-width="auto">
        <!-- <div class="subfield-blue-border"> -->
        <el-form-item :label="$translate('oldPassword')" prop="oldPassword">
          <el-input type="password" v-model.trim="ruleForm.oldPassword" :placeholder="$translate('oldPasswordTips')"></el-input>
        </el-form-item>
        <el-form-item :label="$translate('newPassword')" prop="password">
          <el-input type="password" @input="changEnterPassword" :placeholder="passwordPolicyModel == 2? $translate('intermePassword') : passwordPolicyModel == 3 ? $translate('strengthPassword') : $translate('newPasswordTips')" v-model.trim="ruleForm.password"></el-input>
        </el-form-item>
        <el-form-item :label="$translate('confirmNewPassword')" prop="confirmPassword">
          <el-input type="password" :placeholder="$translate('confirmNewPassword')" v-model.trim="ruleForm.confirmPassword"></el-input>
        </el-form-item>
        <!-- </div> -->
        <!-- <el-form-item>
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="$store.state.loading" @click="submitForm">{{$translate('save')}}</el-button>
        </el-form-item> -->
      </el-form>
      <div class="dialog-footer text-center">
        <el-button class="p-button" size="small" type="primary" @click="submitForm" :loading="$store.state.loading">
          {{ $translate('sure') }}
        </el-button>
        <el-button class="p-button" size="small" @click="cancel">
          {{ $translate('cancel') }}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { ChangePassword } from "../../../api/login.js";
import contentTitle from '../../../components/contentTitle';
import { encrypt } from "../../../utils/encrypt";
export default {
  name: 'ChangePassword',
  components: { contentTitle },
  props: ['closeDialog'],
  data() {
    let validatePass = (rule, value, callback) => {
      // 密码的验证规则 根据密码策略设置，如果type = 1 不限制长度和内容
      //type = 2 则限制密码长度在10~20之间
      //type = 3 则限制密码长度在10~20之间 必须包含数字，字母，特殊字符
      if (value == '') {
        callback(new Error(this.$translate('newPasswordTips')));
      } else {
        if (this.passwordPolicyModel !== 1) {
          if (value.length > 20 || value.length < 10) {
            callback(new Error(this.$translate('newPasswordLengthRangeError')));
          } else {
            callback();
          }
          if (this.passwordPolicyModel == 3) {
            let reg = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{10,20}$/;
            if (!reg.test(value)) {
              callback(new Error(this.$translate('newPasswordContainError')));
            } else {
              callback();
            }
          }
        } else {
          callback();
        }
      }
    }
    let validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$translate('newPasswordConfirmTips')));
      } else if (value !== this.ruleForm.password) {
        callback(new Error(this.$translate('inputPasswordNoSame')));
      } else {
        callback();
      }
    }
    return {
      ruleForm: {
        "oldPassword": "",
        "password": "",
        "confirmPassword": ""
      },
      rules: {

        oldPassword: [{ required: true, message: this.$translate('oldPasswordTips'), trigger: 'change' }],

        password: [{ required: true, validator: validatePass, trigger: 'change' }],

        confirmPassword: [{ required: true, validator: validateConfirmPass, trigger: 'change' }]
      }
    }
  },
  computed: {
    passwordPolicyModel() {
      return (this.$store.state.systemConfig && this.$store.state.systemConfig.passwordPolicyModel && this.$store.state.systemConfig.passwordPolicyModel.type) || 1
    },
  },
  methods: {
    changEnterPassword() {
      if (this.ruleForm.confirmPassword != "") {
        this.$refs.changePasswordForm.validateField('confirmPassword')
      }
    },
    cancel() {
      if (this.closeDialog) {
        this.closeDialog()
      } else {
        this.$router.go(-1)
      }
    },
    changeSuccess() {
      this.$message({
        type: 'success',
        message: this.$translate('goToLogin'),
        onClose: () => {
          this.$store.commit("logout");
        }
      })
    },
    submitForm() {
      this.$refs.changePasswordForm.validate(valid => {
        if (valid) {
          let params = {
            "oldPassword": encrypt(this.ruleForm.oldPassword),
            "password": encrypt(this.ruleForm.password),
            "confirmPassword": encrypt(this.ruleForm.confirmPassword)
          }
          ChangePassword(params).then(res => {
            
            if (res && res.isSuccess) {
              
              if (res.data.isSuccess) {
                this.changeSuccess()
              } else {
                this.$message({
                  type: 'error',
                  showClose: true,
                  message: res.data.message
                })
              }
            }
          })
        }
      })
    }
  }
}

</script>
<style lang="scss" scoped>
.inner-change-password {
  height: 100%;

  .out-message {
    color: red;
    margin-bottom: 15px;
    text-align: center;
  }
  .change-word-form {
    height: calc(100% - 60px);
    background-color: #fff;
    padding: 15px;
    // .el-form {
    //   width: 500px;
    //   margin-left: 15px;
    // }
  }
}
</style>
